import { render, staticRenderFns } from "./xftAbnormal.vue?vue&type=template&id=59af0a29&scoped=true&"
import script from "./xftAbnormal.vue?vue&type=script&lang=js&"
export * from "./xftAbnormal.vue?vue&type=script&lang=js&"
import style0 from "./xftAbnormal.vue?vue&type=style&index=0&id=59af0a29&prod&lang=scss&scoped=true&"
import style1 from "./xftAbnormal.vue?vue&type=style&index=1&id=59af0a29&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59af0a29",
  null
  
)

export default component.exports